import React from "react";
import {
  SearchAddDiv,
  SearchBox,
  SearchContainer,
  SearchIconDiv,
} from "../../style/Table.style";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch } from "react-redux";
import AddModal from "../../modal/AddModal";
import { handleAddOpen } from "../../../redux/Reducer/ModalSlice";
import { ThemButton } from "../../Login/Login.style";

const TableFilter = ({ filter, setFilter, ButtonName }) => {
  const dispatch = useDispatch();
  return (
    <>
      <SearchAddDiv>
        <SearchContainer>
          <SearchIconDiv>
            <SearchIcon />
          </SearchIconDiv>
          <SearchBox
            value={filter || ""}
            onChange={(e) => setFilter(e.target.value)}
            placeholder="Search ...."
            maxLength={50}
          />
        </SearchContainer>
        <div>
          <ThemButton
            onClick={() => dispatch(handleAddOpen())}
            variant="contained"
            startIcon={<AddIcon />}
          >
            {ButtonName}
          </ThemButton>
        </div>
      </SearchAddDiv>
      <AddModal></AddModal>
    </>
  );
};

export default TableFilter;
